var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85 1.5H2.01C1.72833 1.5 1.5 1.72833 1.5 2.00999V5.67999C1.5 5.96166 1.72833 6.19 2.01 6.19H4.85C5.13166 6.19 5.36 5.96166 5.36 5.67999V2.00999C5.36 1.72833 5.13166 1.5 4.85 1.5Z",
    stroke: "#858B97",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28 8.52002H2.01C1.72833 8.52002 1.5 8.74835 1.5 9.03001V15.99C1.5 16.2717 1.72833 16.5 2.01 16.5H7.28C7.56166 16.5 7.79 16.2717 7.79 15.99V9.03001C7.79 8.74835 7.56166 8.52002 7.28 8.52002Z",
    stroke: "#858B97",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.99 8.52002H10.72C10.4383 8.52002 10.21 8.74835 10.21 9.03001V15.99C10.21 16.2717 10.4383 16.5 10.72 16.5H15.99C16.2716 16.5 16.5 16.2717 16.5 15.99V9.03001C16.5 8.74835 16.2716 8.52002 15.99 8.52002Z",
    stroke: "#858B97",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 5.67999V2.00999C16.5 1.72999 16.2701 1.5 15.9901 1.5H8.31005C8.03005 1.5 7.80005 1.72999 7.80005 2.00999V5.67999C7.80005 5.95999 8.03005 6.19 8.31005 6.19H15.9901C16.2701 6.19 16.5 5.95999 16.5 5.67999Z",
    stroke: "#858B97",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonDash);
export default __webpack_public_path__ + "static/media/IKON Dash.4d3084e6ac8ae322b79102a129496e42.svg";
export { ForwardRef as ReactComponent };